<template>
  <div class="products">
    <banner :slides="img" />
    <section class="types" v-show="showList">
      <div class="types-item" v-for="item in categories" :key="item.id">
        <p class="types-item-title">{{ item.categoryName }}</p>
        <p class="types-item-desc">{{ item.summary }}</p>
        <button @click="handleClickType(item.id)" class="btn btn-view">
          了解更多
        </button>
        <img :src="handleCategory(item.categoryPoster)" class="img-fluid" alt />
      </div>
    </section>
    <section class="product" v-show="!showList">
      <div class="type-list">
        <div class="row">
          <div
            @click="handleClickType(item.id)"
            class="col-xl-2 col-4"
            v-for="item in categories"
            :key="item.id"
          >
            <div
              class="type-list-item"
              :class="{ active: item.id === activeCategory }"
            >
              <img :src="item.categoryIcon" :alt="item.categoryName" />
              <p>{{ item.categoryName }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="product-list row">
        <div class="col-lg-6" v-for="item in products" :key="item.id">
          <div class="product-item">
            <div class="row">
              <div class="col-md-6 item-warp" :class="{ 'order-2': $isMobile }">
                <div>
                  <p class="product-item-title">{{ item.goodsName }}</p>
                  <p class="product-item-desc">{{ item.description }}</p>
                </div>

                <!-- <button class="btn btn-view">了解更多</button> -->
                <div class="product-item-bottom">
                  <div v-if="item.price" class="price">￥{{ item.price }}</div>
                  <div v-else class="line"></div>
                </div>
              </div>
              <div
                class="product-item-avatar col-md-6"
                :class="{ 'order-1': $isMobile }"
              >
                <img
                  :src="item.avatar"
                  class="img-fluid"
                  :alt="item.goodsName"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import banner from "@/components/banner.vue";
import img from "../assets/images/banner/jslc1.png";
export default {
  name: "Products",
  components: {
    banner
  },
  data() {
    return {
      img,
      // 切换产品目录
      showList: true,
      categories: [],
      activeCategory: "",
      products: []
    };
  },
  created() {
    this.getCategory();
  },
  mounted() {},
  methods: {
    handleClickType(id) {
      this.showList = false;
      this.activeCategory = id * 1;
      this.getProducts();
    },
    // 处理地址栏参数
    handleUrlParams() {
      let q = this.$route.query;
      if (q && q.id) {
        this.handleClickType(q.id);
      }
    },
    getCategory() {
      this.$api.category.getCategoryList({
		  level:1
	  }).then(res => {
        this.categories = res.result;
        this.$nextTick(() => {
          this.handleUrlParams();
        });
      });
    },
    handleCategory(data) {
      let arr = JSON.parse(data);
      return arr[1];
    },
    getProducts() {
      this.$api.product
        .getProductList({
          pageNo: 1,
          pageSize: 20,
          categoryId: this.activeCategory
        })
        .then(res => {
          if (res.result) {
            this.products = res.result.records;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.products {
  background: #f3f3f3;
  padding-bottom: 60px;
}
.types {
  width: 60%;
  margin: 0 auto;
  text-align: center;
  max-width: 1107px;
  padding: 25px 0;
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 25px 0;
    color: #464646;
    &-title {
      @include responsive-font-size(40px);
      margin-bottom: 1.5rem;
    }
    &-desc {
      margin-bottom: 1rem;
    }
    .btn {
      margin-bottom: 2rem;
    }
    img {
      width: 100%;
    }
  }
}
.product {
  width: 72%;
  margin: 0 auto;
  .type-list {
    margin: 50px 0;
    &-item {
      padding: 1.5rem;
      text-align: center;
      background: rgba(255, 255, 255, 0.5);
      color: #9e9e9e;
      font-size: 20px;
      opacity: 0.83;
      img {
        margin-bottom: 1rem;
      }
      p {
        margin-bottom: 0;
      }
      &:hover {
        font-weight: 600;
        opacity: 1;
      }
    }
    .active {
      background: #ffffff;
      color: #9e9e9e;
      font-weight: 600;
      box-shadow: #ccc 0px 10px 10px;
      opacity: 1;
    }
  }
  &-list {
    .col-lg-6 {
      margin: 15px 0;
    }
    .product-item {
      padding: 60px 30px 20px;
      height: 100%;
      background: #fff;
      color: #464646;
      > .row {
        height: 100%;
      }
      .item-warp {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        // height:90%;
      }
      &-title {
        font-size: 1.6rem;
      }
      &-bottom {
        .line {
          border-bottom: 2px solid;
          width: 20px;
        }
        .price {
          font-size: 18px;
          color: #e84521;
        }
      }
      &:hover {
        box-shadow: #ccc 0px 10px 10px;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .product .type-list-item p {
    font-size: 12px;
  }
}

@include media-breakpoint-down(lg) {
  .products {
    .types {
      padding: 2rem 1rem;

      width: 100%;
      &-item {
        margin: 2rem 0;
        padding: 1rem 0;
        .btn {
          margin-bottom: 1rem;
        }
      }
    }
  }
  .product {
    width: 100%;
    .type-list {
      margin: 0;
      .col-4,
      .row {
        padding: 0;
        margin: 0;
      }
      img {
        width: 30px;
      }
      &-item {
        margin: 0;
        padding: 10px 0;
        font-size: 12px;
        &-bottom {
          opacity: 0;
        }
      }
    }
    &-item {
      &-avatar {
        text-align: center;
      }
    }
  }
}
</style>
